<template>
  <div
    class="waveform-container"
    :class="`${createRenderType}-waveform-container`"
    ref="waveformContainer"
    @click="handleClick"
  >
    <TrackWaveform
      v-for="(item, i) in data"
      :key="i"
      :data="item"
      :progress="progress"
      :backgroundColor="backgroundColorList[i]"
      :duration="duration"
      :class="[
        'track-item',
        i === 3 ? 'track-item-last' : '',
        {
          active: selectedTrackIndex === i,
          inactive: selectedTrackIndex !== null && selectedTrackIndex !== i,
        },
      ]"
      :inActive="selectedTrackIndex !== null && selectedTrackIndex !== i"
      :active="selectedTrackIndex === i"
      @handleSolo="selectTrack(i, item.url, item.title)"
      @handleDown="handleDownOneTrack(item)"
    />
    <div
      class="progress-bar-op"
      :style="{ transform: `translateX(${clampedProgressPx}px)` }"
      ref="progressBar"
    >
      <div class="audio-waveform-op-progress"></div>
      <div class="audio-waveform-op-progress-hover" ref="refProgress"></div>
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  onMounted,
  onBeforeUnmount,
  nextTick,
  watch,
} from "vue"
import { storeToRefs } from "pinia"
import tools from "@/utils/tools.js"
import useCreateLayoutStore from "@/store/create/createLayoutStore.js"
import TrackWaveform from "./trackWaveform.vue"

const createLayoutStore = useCreateLayoutStore()
const { createRenderType } = storeToRefs(createLayoutStore)
const emits = defineEmits([
  "changeTrackProgress",
  "handleSolo",
  "handleDownOneTrack",
])
const props = defineProps({
  data: {
    type: Array,
    default: () => [],
  },
  duration: {
    type: Number,
    default: 0,
  },
  progress: {
    type: Number,
    default: 0,
  }
})

const selectedTrackIndex = ref(null) // 记录被点击的 TrackWaveform

const backgroundColorList = ["#B386FF", "#928CFF", "#82B4FF", "#98C5BB"]
const START_POSITION = ref(createRenderType.value === "pc" ? 136 : 126)
const progressPx = ref(START_POSITION.value)
const clampedProgressPx = ref(START_POSITION.value)
const waveformWidth = ref(0)
const waveformContainer = ref(null)
const progressBar = ref(null)
const refProgress = ref(null)

const renderData = ref({
  touchSwipeState: false,
  transLeft: 0,
  transProgress: 0,
  width: 0,
})
const stateData = ref({
  registTouchWaveBarSwipeStartCall: null,
})

const updateProgressPxByProp = () => {
  if (
    waveformWidth.value > START_POSITION.value &&
    props.progress >= 0 &&
    props.progress <= 100
  ) {
    const width = waveformWidth.value - START_POSITION.value
    const transLeft = (width * props.progress) / 100
    progressPx.value = START_POSITION.value + transLeft
    clampedProgressPx.value = Math.min(
      progressPx.value,
      waveformWidth.value - 2
    )
    renderData.value.transLeft = transLeft
    renderData.value.progress = transLeft / width
  }
}

// 监听 progress 更新进度条位置
watch(
  () => props.progress,
  (newProgress) => {
    if (waveformWidth.value > START_POSITION.value) {
      progressPx.value =
        START_POSITION.value +
        ((waveformWidth.value - START_POSITION.value) * newProgress) / 100
      const width = waveformWidth.value - START_POSITION.value
      const transLeft = (width * newProgress) / 100
      progressPx.value = START_POSITION.value + transLeft
      if (!renderData.value.touchSwipeState) {
        updateProgressPxByProp()
        clampedProgressPx.value = Math.min(
          progressPx.value,
          waveformWidth.value - 2
        )
        renderData.value.transLeft = transLeft
        renderData.value.progress = newProgress / 100
      }
    }
    // if (waveformWidth.value > START_POSITION.value) {
    //   const width = waveformWidth.value - START_POSITION.value
    //   const transLeft = (width * newProgress) / 100
    //   progressPx.value = START_POSITION.value + transLeft
    //   if (!renderData.value.touchSwipeState) {
    //     clampedProgressPx.value = Math.min(
    //       progressPx.value,
    //       waveformWidth.value - 2
    //     )

    //     // ✨ 这里关键！同步 transLeft 位置，确保下一次拖动起始正确
    //     renderData.value.transLeft = transLeft
    //     renderData.value.progress = newProgress / 100
    //   }
    // }
  },
  {
    immediate: true,
  }
)

// 监听 createRenderType 变化
watch(createRenderType, (value) => {
  START_POSITION.value = value === "pc" ? 136 : 126
  nextTick(() => {
    if (waveformContainer.value) {
      waveformWidth.value = waveformContainer.value.clientWidth
      renderData.value.width = waveformWidth.value - START_POSITION.value
    }
  })
})

// 选中 TrackWaveform
const selectTrack = (index, url, title) => {
  if (selectedTrackIndex.value === index) {
    selectedTrackIndex.value = null
    emits("handleSolo", "")
  } else if (selectedTrackIndex.value === null) {
    selectedTrackIndex.value = index
    emits("handleSolo", url, title)
  }
}

// 下载
const handleDownOneTrack = (item) => {
  emits("handleDownOneTrack", item)
}

// 点击进度条更新进度
const handleClick = (event) => {
  if (renderData.value.touchSwipeState) {
    return
  }
  const { left, width } = waveformContainer.value.getBoundingClientRect()
  const offsetX = event.clientX - left
  const progress =
    (offsetX - START_POSITION.value) / (width - START_POSITION.value)
  console.log(progress, "ghghjghg")
  if (progress >= 0 && progress <= 1) {
    emits("changeTrackProgress", progress * 100)
  }
}

const doChangeProgress = (progress) => {
  console.log(progress, "doChangeProgress---")
  if (progress >= 0 && progress <= 1) {
    emits("changeTrackProgress", progress * 100)
  }
}

const initEvent = () => {
  renderData.touchSwipeState = false
  if (props.disableChangeProgress) {
    return
  }
  let transLeft = 0

  stateData.registTouchWaveBarSwipeStartCall = tools.registTouchSwipe(
    progressBar.value,
    {
      direction: "horizontal",
      startCb: (e, actionData) => {
        if (!renderData.value.touchSwipeState) {
          renderData.value.touchSwipeState = true
          transLeft = clampedProgressPx.value - START_POSITION.value
        }
      },
      moveCb: (e, actionData) => {
        const { startX, endX } = actionData
        const dx = Math.floor(endX - startX)
        const { left, width } = waveformContainer.value.getBoundingClientRect()
        let newTransLeft = transLeft + dx
        newTransLeft = Math.max(
          0,
          Math.min(newTransLeft, width - START_POSITION.value)
        )
        clampedProgressPx.value = newTransLeft + START_POSITION.value
        renderData.value.progress =
          newTransLeft / (width - START_POSITION.value)
        console.log(
          renderData.value.progress,
          " moveCb -renderData.value.progress"
        )
      },
      endCb: (e, actionData) => {
        if (renderData.value.touchSwipeState) {
          setTimeout(() => {
            renderData.value.touchSwipeState = false
          }, 10)
          doChangeProgress(renderData.value.progress)
        }
      },
    }
  )
}

onMounted(() => {
  nextTick(() => {
    if (waveformContainer.value) {
      waveformWidth.value = waveformContainer.value.clientWidth
      renderData.value.width = waveformWidth.value - START_POSITION.value
      updateProgressPxByProp()
    }
    initEvent()
  })
})

onBeforeUnmount(() => {
  if (stateData.value.registTouchWaveBarSwipeStartCall) {
    stateData.value.registTouchWaveBarSwipeStartCall()
  }
})
</script>

<style lang="scss" scoped>
.waveform-container {
  position: relative;
  width: 100%;
  height: auto;
  overflow: hidden;
  transition: background-color 0.2s ease-in-out; // 平滑过渡

  .track-item {
    margin-bottom: 6px;
    transition: opacity 0.2s ease-in-out;

    &-last {
      margin-bottom: 0px;
    }
    &.active {
      opacity: 1 !important;
    }
    &.inactive {
      opacity: 0.3;
    }
  }

  .progress-bar-op {
    position: absolute;
    width: 0px;
    height: 100%;
    top: 0;
    bottom: 0;
    transform: scale(1, 1);
    transform-origin: center center;

    .audio-waveform-op-progress {
      position: absolute;
      width: 1px;
      height: 100%;
      background: #fff;
      left: -1px;
      top: 0;
    }

    .audio-waveform-op-progress-hover {
      position: absolute;
      width: 12px;
      height: 100%;
      background: transparent;
      left: -6px;
      top: 0;

      &:hover {
        background: rgba(255, 255, 255, 0.5);
      }
    }
  }
}

.mobile-waveform-container {
  .track-item {
    margin-bottom: 4px;
    &-last {
      margin-bottom: 0px;
    }
  }
}
</style>
